import { render, staticRenderFns } from "./requests-detail.vue?vue&type=template&id=f6f0d74c&"
import script from "./requests-detail.vue?vue&type=script&lang=js&"
export * from "./requests-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports